import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Button, Space } from 'antd';
// import { ColumnsType } from 'antd/es/table';
import {
  EditOutlined,
  FileTextOutlined,
  TrophyOutlined,
  RiseOutlined,
  ReadOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { analysisAPI, essayAPI } from '../services/api';
import { Essay } from '../types';
import EssayListTable from '../components/EssayListTable';
import './HomePage.css';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalEssays: 0,
    averageScore: 0,
    latestScore: 0,
    improvement: 0,
  });
  const [recentEssays, setRecentEssays] = useState<Essay[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // 获取统计数据
      const statsRes = await analysisAPI.getStats();
      if (statsRes.data) {
        setStats({
          totalEssays: statsRes.data.total_essays || 0,
          averageScore: statsRes.data.average_score || 0,
          latestScore: statsRes.data.latest_score || 0,
          improvement: statsRes.data.recent_progress || 0,
        });
      }

      // 获取最近的作文
      const essaysRes = await essayAPI.list({ page: 1, page_size: 5 });
      setRecentEssays(essaysRes.data.data || []);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="home-page student-home-page">
      <section className="student-hero">
        <div className="student-hero-copy">
          <span className="student-kicker">英语作文批改系统</span>
          <h2>今天写一篇，改掉一个薄弱点</h2>
          <p>每次批改都留下一条清楚的进步线，下一篇作文会更稳。</p>
          <Space wrap size={[12, 12]}>
            <Button
              type="primary"
              size="large"
              icon={<EditOutlined />}
              onClick={() => navigate('/essay/new')}
            >
              开始批改
            </Button>
            <Button size="large" icon={<ReadOutlined />} onClick={() => navigate('/history')}>
              查看批改记录
            </Button>
          </Space>
        </div>
        <div className="student-hero-visual" aria-hidden="true">
          <div className="student-book" />
          <div className="student-pencil" />
          <div className="student-spark student-spark-a" />
          <div className="student-spark student-spark-b" />
        </div>
      </section>
      
      <Row gutter={[16, 16]} className="student-stats-row">
        <Col xs={24} sm={12} lg={6}>
          <Card className="student-stat-card student-stat-total">
            <Statistic
              title="总作文数"
              value={stats.totalEssays}
              prefix={<FileTextOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="student-stat-card student-stat-average">
            <Statistic
              title="平均分数"
              value={stats.averageScore}
              precision={1}
              suffix="分"
              prefix={<TrophyOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="student-stat-card student-stat-latest">
            <Statistic
              title="最新分数"
              value={stats.latestScore}
              precision={1}
              suffix="分"
              prefix={<EditOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card className="student-stat-card student-stat-progress">
            <Statistic
              title="最近进步"
              value={stats.improvement}
              precision={1}
              suffix="分"
              prefix={<RiseOutlined />}
              valueStyle={{ color: stats.improvement > 0 ? '#16866c' : '#d85c45' }}
            />
          </Card>
        </Col>
      </Row>

      <Card
        className="student-list-card"
        title="最近批改"
        extra={<Button onClick={() => navigate('/history')}>查看全部</Button>}
      >
        <EssayListTable
          essays={recentEssays}
          loading={loading}
          pagination={false}
          showActions={true}
        />
      </Card>

      <Card className="student-quick-card">
        <div>
          <RocketOutlined />
          <strong>本周批改重点</strong>
          <span>完成 2 篇作文批改并复盘常见错误。</span>
        </div>
        <Button
          type="primary"
          size="large"
          icon={<EditOutlined />}
          onClick={() => navigate('/essay/new')}
        >
          继续批改
        </Button>
      </Card>
    </div>
  );
};

export default HomePage;
